import { FC } from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import ReusableModal from '../common/Modal';
import { Trash } from '@phosphor-icons/react';

interface DeleteModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  isPending: boolean;
  title?: string;
  description?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const DeleteModal: FC<DeleteModalProps> = ({
  open,
  onClose,
  onDelete,
  isPending,
  title = 'Delete',
  description = 'Are you sure? This action cannot be undone and will delete the associated data.',
  confirmButtonText = 'Delete',
  cancelButtonText = 'Cancel',
}) => {
  return (
    <ReusableModal
      open={open}
      onClose={onClose}
      title={title}
      width={500}
      backgroundColor="rgba(231, 76, 60, 0.15);"
    >
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography
          fontSize={14}
          fontWeight={400}
          lineHeight={1.5}
          letterSpacing={-0.14}
          color="text.secondary"
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 2,
            pt: 2,
            borderTop: '1px solid #DCE0E7',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              flex: 1,
              color: 'custom.textBlue',
              fontWeight: 500,
              fontSize: '14px',
            }}
          >
            {cancelButtonText}
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={onDelete}
            startIcon={
              isPending ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <Trash size={16} />
              )
            }
            disabled={isPending}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              flex: 1,
              bgcolor: 'error.main',
              boxShadow: 'none',
            }}
          >
            {isPending ? 'Deleting...' : confirmButtonText}
          </Button>
        </Box>
      </Box>
    </ReusableModal>
  );
};

export default DeleteModal;
